import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from './AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthContext();
  
  // Hiển thị loading nếu đang kiểm tra authentication
  if (loading) {
    return <LoadingSpinner message="Đang kiểm tra quyền truy cập..." />;
  }
  
  // Nếu đã đăng nhập, chuyển hướng về dashboard
  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  
  // Nếu chưa đăng nhập, cho phép truy cập trang công khai
  return children;
};

export default PublicRoute; 